export default __webpack_public_path__ + "static/media/rates-update.f0cf8577.png";